import { render, staticRenderFns } from "./SimpleTextBlock.vue?vue&type=template&id=069253eb"
import script from "./SimpleTextBlock.vue?vue&type=script&lang=js"
export * from "./SimpleTextBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports